<div class="category-description">Categories help organize your zones and provide an extra level of customization.</div>
<div class="category-content" fxLayout="column">
  <app-search-bar (searchTerm)="searchTerm$.next($event)"></app-search-bar>
  <div class="category-list" *ngIf="(categories$ | async) as categories; else loading">
  <ng-container *ngTemplateOutlet="errorMsg ? errorMessage : categoryList; context: { $implicit: categories }"></ng-container>
 </div>
</div>
<div class="category-actions">
  <button class="category-create-btn" (click)="createCategory()">Create category</button> 
</div>

<ng-template #categoryList let-categories>
  <ng-container *ngIf="categories.length <= 0">
    <div class="no-result">No category found</div>
  </ng-container>
   
  <ng-container *ngIf="categories.length > 0">
    <div *ngFor="let category of categories" class="category-item" (click)="selectCategory(category)"
      fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px">
      <span class="category-color" [ngStyle]="getStyles(category)"></span>
      <div class="category-name">{{ category.name }}</div>
    </div>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="category-loading-spinner">
    <app-spinner></app-spinner>
  </div>
</ng-template>

<ng-template #errorMessage>
  <div class="category-error-message">{{ errorMsg }}</div>
</ng-template>
